(function () {
  function rootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function sectionsToRender() {
    var helper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
    if (helper && typeof helper.getSectionsToRender === 'function') {
      return helper.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    return ['cart-drawer'];
  }

  function card(el) {
    return el && el.closest ? el.closest('[data-amc-cart-addon]') : null;
  }

  function variantEl(item) {
    return item.querySelector('[data-amc-addon-variant]');
  }

  function qtyInput(item) {
    return item.querySelector('[data-amc-addon-qty-input]');
  }

  function syncPrice(item) {
    if (!item) return;
    var control = variantEl(item);
    var price = item.querySelector('[data-amc-addon-price]');
    if (!control || !price) return;
    var source = control.tagName === 'SELECT' ? control.options[control.selectedIndex] : control;
    if (source && source.dataset.price) price.textContent = source.dataset.price;
  }

  function stepQty(item, delta) {
    if (!item) return;
    var input = qtyInput(item);
    if (!input) return;
    var next = parseInt(input.value, 10) + delta;
    if (isNaN(next) || next < 1) next = 1;
    input.value = next;
  }

  function addToCart(item, button) {
    if (!item || !button || button.disabled) return;

    var control = variantEl(item);
    var input = qtyInput(item);
    if (!control || !control.value) return;

    var quantity = parseInt(input && input.value, 10);
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    button.disabled = true;
    button.removeAttribute('aria-invalid');
    button.removeAttribute('title');

    fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(control.value), quantity: quantity }],
        sections: sectionsToRender(),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'Add to cart failed');
        }
        var helper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
        if (helper && typeof helper.reRenderSections === 'function' && response.sections) {
          helper.reRenderSections(response.sections);
        }
        var bubble = document.querySelector('#cart-icon-bubble span');
        if (helper && bubble) {
          helper.currentItemCount = parseInt(bubble.innerHTML, 10);
        }
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      })
      .catch(function (err) {
        button.setAttribute('aria-invalid', 'true');
        button.setAttribute('title', err.message || 'Add to cart failed');
      })
      .finally(function () {
        button.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var minus = target.closest('[data-amc-addon-minus]');
    if (minus) {
      stepQty(card(minus), -1);
      return;
    }

    var plus = target.closest('[data-amc-addon-plus]');
    if (plus) {
      stepQty(card(plus), 1);
      return;
    }

    var add = target.closest('[data-amc-addon-add]');
    if (add) {
      e.preventDefault();
      addToCart(card(add), add);
    }
  });

  document.addEventListener('change', function (e) {
    var select = e.target && e.target.closest && e.target.closest('[data-amc-addon-variant]');
    if (select) syncPrice(card(select));
  });
})();
